import { defineMessages } from 'react-intl';

export default defineMessages({

    processDate: {
        id: 'ri.gateway.billingTransactions.Process Date',
        defaultMessage: 'Process Date'
    },
    transactionType: {
        id: 'ri.gateway.billingTransactions.Transaction Type',
        defaultMessage: 'Transaction Type'
    },
    transactionAmount: {
        id: 'ri.gateway.billingTransactions.Transaction Amount',
        defaultMessage: 'Transaction Amount'
    },
    noBillingTransactionDataLabel: {
        id: 'ri.gateway.billingTransactions..No Billing transactions data for this policy, check back again in the next',
        defaultMessage: 'No billing transactions data for this policy, check back again in the next 24 hour'
    }
});
